import type { CourseDraftCreateLocalizedBasicInfo } from './courseDraftCreateLocalizedBasicInfo';
import type { CourseDraftCreateLocalizedSections } from './courseDraftCreateLocalizedSections';
import type { CourseDraftCreatePrice } from './courseDraftCreatePrice';

/**
 * 코스 초안 생성 요청
 */
export interface CourseDraftCreate {
  /**
   * 기본 정보 편집 시 활성화된 언어 코드
   * @nullable
   */
  activeBasicInfoLanguage?: string | null;
  /**
   * 현재 활성화된 편집 언어 코드
   * @nullable
   */
  activeLanguage?: string | null;
  /** 댓글 허용 여부 (기본값 true) */
  allowComments?: boolean;
  /** 기본 언어 코드 (미지정 시 ko) */
  defaultLanguage?: string;
  /**
   * 코스 설명
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  /** 공개 여부 (기본값 true) */
  isPublic?: boolean;
  /**
   * 코스 난이도 (자유 텍스트 입력)
   * @minLength 1
   * @maxLength 50
   * @nullable
   */
  level?: string | null;
  /** 언어별 기본 정보 매핑 */
  localizedBasicInfo?: CourseDraftCreateLocalizedBasicInfo;
  /** 언어별 섹션 정보 매핑 */
  localizedSections?: CourseDraftCreateLocalizedSections;
  /**
   * 코스 가격 정보
   * @nullable
   */
  price?: CourseDraftCreatePrice;
  /** 지원 언어 목록 */
  supportedLanguages?: string[];
  /**
   * 썸네일 이미지 URL
   * @nullable
   */
  thumbnailUrl?: string | null;
  /**
   * 코스 제목
   * @minLength 1
   * @maxLength 200
   */
  title: string;
}
